import React from 'react';

import styled from 'styled-components';

import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import { StyledMobileBoxItemRow } from '../../utils/Styles/DataBoxStyles';
import { BACH2SourceMetadata } from '../../../types/Activity';
import { StripeAccount } from '../../../types/Stripe';
import { defaultSourceOptions } from '../ActivityMetaFields/ActivitySourceOptions';

const StyledValidationMessage = styled.div`
  color: red;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: -10px;
`;

type Props = {
  initialCommission: number;
  isEditMode: boolean;
  metadata: BACH2SourceMetadata | undefined;
  onChange(prop: string, value: any): void;
  showErrors: boolean;
  stripeAccounts: StripeAccount[];
  source: string;
};

const ConnectStripeAccountFormMobile = ({
  initialCommission,
  isEditMode,
  metadata,
  onChange,
  showErrors,
  stripeAccounts,
  source,
}: Props) => {
  const stripeId: string = metadata?.stripeId ?? '';
  const commission = initialCommission ?? undefined;
  const label = defaultSourceOptions.find(item => item.value === source)?.label;
  return (
    <>
      <StyledMobileBoxItemRow
        maxWidth='100%'
        isEditableRow
        isMobileEditMode={isEditMode}
      >
        <span className='field-label'>Stripe ID:</span>
        {isEditMode ? (
          <SimpleSelect
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onChange={value =>
              onChange('metadata', {
                ...metadata,
                stripeId: value,
              })
            }
            value={stripeId}
            name='stripeId'
            data={stripeAccounts.map(v => ({
              label: `ID: ${v.id}, businessName: ${v.businessName}, email: ${v.email}`,
              value: v.id,
            }))}
          />
        ) : (
          <span>{stripeId}</span>
        )}
      </StyledMobileBoxItemRow>
      {showErrors && stripeId.length < 1 && (
        <StyledValidationMessage>
          Experiences with a source of {label} must have a Stripe ID
        </StyledValidationMessage>
      )}
      <StyledMobileBoxItemRow
        maxWidth='100%'
        isEditableRow
        isMobileEditMode={isEditMode}
      >
        <span className='field-label'>Commission:</span>
        <span>{commission}</span>
      </StyledMobileBoxItemRow>
      {!commission && commission !== 0 && (
        <StyledValidationMessage>
          Experiences with a source of {label} must have a commission. Please
          set a commission above.
        </StyledValidationMessage>
      )}
    </>
  );
};

export default ConnectStripeAccountFormMobile;
